import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postOnboardingLink, postDashboardLink } from "../api/payments";
import { usePaymentAccountStore } from "../store/paymentAccountSlice";

export function usePaymentActions() {
  const qc = useQueryClient();
  const { setRedirecting } = usePaymentAccountStore();

  const returnUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}/settings?tab=payments`
      : "";

  const initiateOnboarding = useMutation({
    mutationFn: () =>
      postOnboardingLink(returnUrl, returnUrl),
    onMutate: () => setRedirecting(true),
    onSuccess: (data) => {
      window.location.href = data.onboarding_url;
    },
    onError: () => setRedirecting(false),
  });

  const openDashboard = useMutation({
    mutationFn: postDashboardLink,
    onSuccess: (data) => {
      window.open(data.dashboard_url, "_blank");
      qc.invalidateQueries({ queryKey: ["paymentAccount"] });
    },
  });

  return { initiateOnboarding, openDashboard };
}
